module.exports = __webpack_public_path__ + "static/img/echodot.7c5577b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/echodot.png
// module id = uG8G
// module chunks = 0